import { easeOutCubic } from 'easing-utils';

const NumberCounter = () => {

    document.querySelectorAll('[num]').forEach(numberElem => {

        function animateStats() {

            // Initial values
            const finalValue = parseInt(numberElem.getAttribute('num'), 10);
            const animTime = parseInt(numberElem.getAttribute('time'), 10);
            const initTime = performance.now();

            // Interval
            let interval = setInterval(function() {
                let time = (performance.now() - initTime) / animTime;

                let currentValue = Math.floor(easeOutCubic(time) * finalValue);
                // return string value with thousands , separator
                numberElem.innerText = currentValue.toLocaleString("en-GB");

                if (time >= 1) {
                    clearInterval(interval);
                }
            }, 50);

        }

        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        };

        let observer = new IntersectionObserver(animateStats, options);
        const components = document.querySelectorAll('.stats-four-col');

        components.forEach(component => {
            observer.observe(component);
        })

    });

}

export default NumberCounter